import { Nav, NavItem } from 'reactstrap';
import styles from './Navigation.module.scss';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import ProfileCard from '../../../global/Components/ProfileCard/ProfileCard';
import { useLogout } from '../../../global/utils/hooks/useLogout';
import useAuth from '../../../global/utils/hooks/useAuth';
import { useState } from 'react';
import ChargeCard from '../../../global/Components/Charge/ChargeCard';


export default function Navigation({user, onCloseOffCanvas, width}) {
    const { lang } = useContext(UserContext);
    const logout = useLogout();
    const auth = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const [isSeller, setIsSeller] = useState(auth.auth.roles);
    
    const image = false;

    const signout = () => {
        logout();
    }

    const handleLink = (link) => {
        navigate(`${link}`);
        width < 1025 && onCloseOffCanvas();
    }

  return (
    <div className={`bg-white lgtBackground`}>
        <div className={`${styles.userWrapper} p-4`}>
            <ProfileCard 
                isImage={false} 
                isArrow={true}
                id={auth.auth.userInfo.user.id}
                username={auth.auth.userInfo.user.username}
                firstName={user.first_name}
                lastName={user.last_name}
                avatar={user.avatar}
                 />
        </div>
        <div className='bottonDivider' />
        <ChargeCard balance={user.balance} />
        <div className='bottonDivider' />
        <div className={`p-4 ${styles.navigation}`}>
            <Nav vertical navbar>
                <NavItem>
                    <span onClick={() => handleLink('user-profile')} className={`${styles.navLink} ${location.pathname == "/dashboard/user-profile" ? styles.active : ""} nav-link`}>
                        <i className={`bi bi-person me-2`}></i>
                        {showMsg('my_profile',lang)}
                    </span>
                </NavItem>
                <NavItem>
                    <span onClick={() => handleLink('add-product')} className={`${styles.navLink} ${location.pathname == "/dashboard/add-product" ? styles.active : ""} nav-link ${isSeller == 'no' && styles.disabled}`}>
                        <i className={`bi bi-plus-square me-2`}></i>
                        {showMsg('add_product',lang)}
                    </span>
                </NavItem>
                <NavItem>
                    <span onClick={() => handleLink('my-products')} className={`nav-link ${styles.navLink} ${location.pathname == "/dashboard/my-products" ? styles.active : ""} ${isSeller == 'no' && styles.disabled}`}>
                        <i className={`bi bi-box-seam me-2`}></i>
                        {showMsg('my_products',lang)}
                    </span>
                </NavItem>
                <NavItem>
                    <span onClick={() => handleLink('my-orders')} className={`nav-link ${styles.navLink} ${location.pathname == "/dashboard/my-orders" ? styles.active : ""}`}>
                        <i className={`bi bi-bag me-2`}></i>
                        {showMsg('my_orders',lang)}
                    </span>
                </NavItem>
                <NavItem>
                    <span onClick={() => handleLink('wishlist')} className={`nav-link ${location.pathname == "/dashboard/wishlist" ? styles.active : ""} ${styles.navLink}`}>
                        <i className={`bi bi-bookmark me-2`}></i>
                        {showMsg('wishlist',lang)}
                    </span>
                </NavItem>
                <NavItem>
                    <span  onClick={() => handleLink('my-transactions')} className={`nav-link ${location.pathname === "/dashboard/my-transactions" ? styles.active : ""} ${styles.navLink}`}>
                        <i className={`bi bi-coin me-2`}></i>
                        {showMsg('my-transactions',lang)}
                    </span>
                </NavItem>
                {/* <NavItem>
                    <NavLink to='users' className={`nav-link ${location.pathname == "/dashboard/users" ? styles.active : ""} ${styles.navLink}`}>
                        <i className={`bi bi-file-earmark-bar-graph me-2`}></i>
                        {showMsg('payment_report',lang)}
                    </NavLink>
                </NavItem> */}
                <NavItem>
                    <NavLink onClick={signout}  className={`nav-link ${styles.navLink} text-danger`}>
                        <i className={`bi bi-box-arrow-left me-2`}></i>
                        {showMsg('logout',lang)}
                    </NavLink>
                </NavItem>
            </Nav>
        </div>
    </div>
  )
}
